import * as React from 'react';
import Popover from '@mui/material/Popover';
import clsx from 'clsx';
import LabelComponent from 'components/label/labelComponent';
import { ErrorContainer } from 'components/errorContainer';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import style from './dateAndTimePopover.module.scss';
import DatePicker from '../datePicker';
import { TimePicker } from './timePickerPopover';

dayjs.extend(customParseFormat);

export const isDateTodayOrPast = (date: any) => {
  const today = dayjs().endOf('day'); // Today at 23:59:59
  return !dayjs(date).isAfter(today, 'day'); // Allows today & past dates, prevents future dates
};

export default function DateAndTimePopoverContainer({
  dateHandleChange,
  dateHandleBlur,
  dateValue,
  isDateDisabled,
  isDateErrorVisible,
  dateErrors,
  dateName,
  timeName,
  timeHandleChange,
  timeHandleBlur,
  timeSpentValue,
  isTimeFormDisabled,
  isTimeSpentErrorVisible,
  timeSpentErrors
}: {
  isDateDisabled: any;
  dateHandleChange: (value: any) => void;
  dateHandleBlur: (value: any) => void;
  dateValue: any;
  dateName: string;
  isDateErrorVisible: boolean;
  dateErrors: any;
  timeName: string;
  timeHandleChange: (value: any) => void;
  timeHandleBlur: (value: any) => void;
  timeSpentValue: any;
  isTimeFormDisabled: boolean;
  isTimeSpentErrorVisible: any;
  timeSpentErrors: any;
}) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const [localTimeSpent, setLocalTimeSpent] = React.useState<React.ReactNode | null>();
  console.log('localTimeSpent: ', localTimeSpent);

  const [localStartDate, setLocalStartDate] = React.useState<React.ReactNode | null>();
  console.log('localStartDate: ', localStartDate);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLocalDateChange = (date: any) => {
    dateHandleChange(date);
  };
  const handleLocalTimeChange = (time: any) => {
    timeHandleChange(time);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  React.useEffect(() => {
    if (
      dateValue &&
      dateValue !== 'Invalid Date' &&
      dayjs(dateValue).isValid() &&
      isDateTodayOrPast(dateValue)
    ) {
      setLocalStartDate(dayjs(dateValue).format('MMM DD'));
    }

    if (
      timeSpentValue &&
      timeSpentValue !== 'Invalid Date' &&
      dayjs(timeSpentValue, ['hh:mm A', 'HH:mm:ss'], true).isValid()
    ) {
      setLocalTimeSpent(dayjs(timeSpentValue, ['hh:mm A', 'HH:mm:ss'], true).format('h:mm A'));
    }
    if (!dateValue || !isDateTodayOrPast(dateValue)) {
      setLocalStartDate(null);
    }
    if (!timeSpentValue || timeSpentValue === 'Invalid Date') {
      setLocalTimeSpent(null);
    }
    console.log('ue dateValue: ', dateValue);
    console.log('ue timeSpentValue: ', timeSpentValue);
  }, [dateValue, timeSpentValue]);

  return (
    <div>
      <button
        onClick={handleClick}
        className={clsx(
          style.popoverButton,
          style.withGradient,
          (isDateDisabled || isTimeFormDisabled) && style.disabled
        )}
        type="button"
      >
        {(!dateValue || dateValue === 'Invalid Date') &&
          (!timeSpentValue || timeSpentValue === 'Invalid Date') && (
            <div className={style.placeholderInsidePopover}>Select</div>
          )}
        {(dateValue || timeSpentValue) && (
          <div
            className={clsx(
              style.valueInsidePopover,
              (isDateDisabled || isTimeFormDisabled) && style.disabled
            )}
          >
            {localStartDate}
            {localTimeSpent && localStartDate && <div className={style.separator}>|</div>}

            {localTimeSpent}
          </div>
        )}
      </button>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        sx={{
          '& .MuiPaper-root': {
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow:
              '1px 1px 4px 0px rgba(80, 117, 177, 0.20), 4px 4px 25px 0px rgba(80, 117, 177, 0.15)',
            overflow: 'hidden'
          }
        }}
        anchorReference="anchorPosition"
        anchorPosition={{
          top: Number(anchorEl && anchorEl?.getBoundingClientRect()?.bottom + 6),
          left: Number(anchorEl?.getBoundingClientRect()?.left) - 0.4
        }}
      >
        <div className={style.popoverContainer}>
          <LabelComponent mandatory text="Date of Encounter" />
          <DatePicker
            withGradient
            onChange={(date: string) => {
              handleLocalDateChange(date);
            }}
            onBlur={(e: unknown) => dateHandleBlur(e)}
            value={dateValue}
            placeholder="MM/DD/YYYY"
            disabled={isDateDisabled}
            maxDate={dayjs()}
          />
          <ErrorContainer visible={isDateErrorVisible} errors={dateErrors} name={dateName} />
          <LabelComponent mandatory text="Time" />
          <TimePicker
            classnamesProps={clsx(style.withGradient)}
            disabled={isTimeFormDisabled}
            name={timeName}
            onChange={(time: string) => handleLocalTimeChange(time)}
            onBlur={(e: unknown) => timeHandleBlur(e)}
            value={
              dayjs(timeSpentValue, ['hh:mm A', 'HH:mm:ss'], true).isValid()
                ? dayjs(timeSpentValue, ['hh:mm A', 'HH:mm:ss'], true).format('HH:mm:ss')
                : null
            }
            showIcon={true}
          />
          <ErrorContainer
            visible={isTimeSpentErrorVisible}
            errors={timeSpentErrors}
            name={timeName}
          />
        </div>
      </Popover>
    </div>
  );
}
